export type MarketingSlug =
  | 'null-program'
  | 'mini-program'
  | 'midi-program'
  | 'maxi-program'
  | 'auto-program'
  | 'home-program'
  | 'keys-program'
  | 'kitty-one'
  | 'cat-one'
  | 'cat-two'
  | 'cat-three'
  | 'cat-four'
  | 'cat-five'
  | 'ashot-program'
  | 'shot-program'
  | 'take'
  | 'bank-program'
  | 'vzlet-program'
  | 'real-program'
  | 'real-top-program'
  | 'btc-in'
  | 'btc-yan'
  | 'btc-BITYARD';

export type MarketingKey =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24;

type MarketingMap = {
  [key in MarketingKey]: { slug: MarketingSlug };
};

export const marketings: MarketingMap = {
  7: { slug: 'null-program' },
  1: { slug: 'mini-program' },
  2: { slug: 'midi-program' },
  3: { slug: 'maxi-program' },
  4: { slug: 'auto-program' },
  5: { slug: 'home-program' },
  18: { slug: 'keys-program' },
  15: { slug: 'kitty-one' },
  10: { slug: 'cat-one' },
  11: { slug: 'cat-two' },
  12: { slug: 'cat-three' },
  13: { slug: 'cat-four' },
  14: { slug: 'cat-five' },
  17: { slug: 'ashot-program' },
  9: { slug: 'shot-program' },
  8: { slug: 'take' },
  16: { slug: 'bank-program' },
  19: { slug: 'vzlet-program' },
  20: { slug: 'real-program' },
  21: { slug: 'real-top-program' },
  22: { slug: 'btc-BITYARD' },
  23: { slug: 'btc-in' },
  24: { slug: 'btc-yan' },
};

export interface Program {
  name: string;
  id: MarketingKey;
  level: number;
  timeStart?: string | Date; // Опциональное поле
  curr?: string;
}

export const programs: Program[] = [
  { name: 'MINI', id: 1, level: 11 },
  { name: 'MIDI', id: 2, level: 50 },
  { name: 'MAXI', id: 3, level: 250 },
  { name: 'AUTO', id: 4, level: 3000 },
  { name: 'HOME', id: 5, level: 30000 },
  // { name: 'SPACE', id: 6, level: 10 },
  { name: 'NULL', id: 7, level: 6 },
  { name: 'TAKE', id: 8, level: 1.1 },
  { name: 'SHOT', id: 9, level: 101 },
  { name: 'CAT1', id: 10, level: 30 },
  { name: 'CAT2', id: 11, level: 60 },
  { name: 'CAT3', id: 12, level: 120 },
  { name: 'CAT4', id: 13, level: 240 },
  { name: 'CAT5', id: 14, level: 480 },
  { name: 'KITTY', id: 15, level: 3.1 },
  { name: 'BANK', id: 16, level: 2 },
  { name: 'ASHOT', id: 17, level: 35 },
  { name: 'KEYS', id: 18, level: 51 },
  { name: 'VZLET', id: 19, level: 601 },
  { name: 'REAL', id: 20, level: 5.1 },
  { name: 'REAL TOP', id: 21, level: 31 },
  {
    name: 'BITYARD',
    id: 22,
    level: 0.000565,
    timeStart: 'Thu Dec 25 2025 15:00:00 GMT+0300 (Москва, стандартное время)',
    curr: 'btc',
  },
  {
    name: 'ИНЬ',
    id: 23,
    level: 0.000008,
    timeStart: 'Fri Dec 26 2025 15:00:00 GMT+0300 (Москва, стандартное время)',
    // timeStart: 'Thu Dec 18 2025 14:10:00 GMT+0300 (Москва, стандартное время)',
    curr: 'btc',
  },
  {
    name: 'ЯНЬ',
    id: 24,
    level: 0.000085,
    timeStart: 'Fri Dec 26 2025 14:00:00 GMT+0300 (Москва, стандартное время)',
    curr: 'btc',
  },
];
